export default {
  // 表格列標題
  counterparty: "交易對手",
  inflowAmount: "轉入數量(USDT)",
  inflowCount: "轉入次數(USDT)",
  outflowAmount: "轉出數量(USDT)",
  outflowCount: "轉出次數(USDT)",

  // 加載和狀態
  loading: "拼命加載中",
  noData: "暫無數據",

  // 下載
  downloadDetails: "下載數據明細",
  downloadNote: "注：最多可下載10萬條數據",

  // 消息提示
  copySuccess: "複製成功",
};
